export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div className="md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/0d5a057c-0f37-4ad7-ac1e-9a4e973b64d1.png" 
              alt="James Cleaning" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-600 italic mb-6">
              Making homes sparkle, one clean at a time
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4 text-sm uppercase tracking-wide">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('booking')} className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Booking
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-gray-900 mb-4 text-sm uppercase tracking-wide">Contact Info</h3>
            <div className="space-y-4">
              <a href="tel:+61412345678" className="flex items-center gap-3 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl text-teal-600"></i>
                <span className="text-lg font-semibold">0412 345 678</span>
              </a>
              <a href="mailto:info@jamescleaning.com.au" className="flex items-center gap-3 text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl text-teal-600"></i>
                <span>info@jamescleaning.com.au</span>
              </a>
              <div className="flex items-start gap-3 text-gray-600">
                <i className="ri-map-pin-line text-xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                <span>Melbourne &amp; Surrounding Suburbs, VIC</span>
              </div>
              <button
                onClick={() => scrollToSection('booking')}
                className="bg-teal-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-teal-700 transition-all hover:shadow-lg whitespace-nowrap cursor-pointer inline-block"
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <p>&copy; 2025 James Cleaning. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-teal-600 transition-colors cursor-pointer">Privacy Policy</a>
              <span>|</span>
              <a href="#" className="hover:text-teal-600 transition-colors cursor-pointer">Terms of Service</a>
              <span>|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal-600 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
